import React, { useState } from 'react';
import ModernHeader from '../components/ModernHeader';
import Footer from '../components/Footer';
import { useSettings } from '../context/SettingsContext';

const ContactSupport = () => {
  const { settings } = useSettings();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for contacting us! We will get back to you within 24 hours.');
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
      <ModernHeader tenant={{ name: 'Tiket Jini' }} />
      <div style={{ maxWidth: '800px', margin: '0 auto', background: 'white', borderRadius: '20px', padding: '40px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', marginTop: '40px', marginBottom: '40px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src="/Logo1.png" alt="Tiket Jini" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '20px' }} />
          <h1 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#2d3748', marginBottom: '10px' }}>Contact Support</h1>
          <p style={{ color: '#64748b', fontSize: '1.1rem' }}>We're here to help you 24/7</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : '1fr 1fr', gap: '40px' }}>
          {/* Contact Information */}
          <div>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '20px' }}>📞 Get in Touch</h2>
            
            <div style={{ marginBottom: '25px', padding: '20px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <h3 style={{ color: '#3b82f6', marginBottom: '10px', fontSize: '1.1rem' }}>📧 Email Support</h3>
              <p style={{ margin: 0, color: '#4a5568' }}>{settings.supportEmail}</p>
              <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#64748b' }}>Response within 2-4 hours</p>
            </div>

            <div style={{ marginBottom: '25px', padding: '20px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <h3 style={{ color: '#3b82f6', marginBottom: '10px', fontSize: '1.1rem' }}>📱 Phone Support</h3>
              <p style={{ margin: 0, color: '#4a5568' }}>{settings.supportPhone}</p>
              <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#64748b' }}>Available 24/7</p>
            </div>

            <div style={{ marginBottom: '25px', padding: '20px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <h3 style={{ color: '#3b82f6', marginBottom: '10px', fontSize: '1.1rem' }}>💬 Live Chat</h3>
              <p style={{ margin: 0, color: '#4a5568' }}>Available on website</p>
              <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#64748b' }}>Instant responses</p>
            </div>

            <div style={{ padding: '20px', background: '#fff3cd', borderRadius: '12px', border: '1px solid #ffc107' }}>
              <h3 style={{ color: '#856404', marginBottom: '10px', fontSize: '1.1rem' }}>🚨 Emergency Support</h3>
              <p style={{ margin: 0, color: '#856404' }}>For urgent booking issues during your visit</p>
              <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#856404', fontWeight: 'bold' }}>Call: {settings.supportPhone}</p>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '20px' }}>✉️ Send us a Message</h2>
            
            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '20px' }}>
              <input
                type="text"
                placeholder="Your Name *"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
                style={{
                  padding: '12px 16px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.3s'
                }}
              />
              
              <input
                type="email"
                placeholder="Email Address *"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
                style={{
                  padding: '12px 16px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.3s'
                }}
              />
              
              <input
                type="tel"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                style={{
                  padding: '12px 16px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.3s'
                }}
              />
              
              <select
                value={formData.subject}
                onChange={(e) => setFormData({...formData, subject: e.target.value})}
                required
                style={{
                  padding: '12px 16px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.3s'
                }}
              >
                <option value="">Select Subject *</option>
                <option value="booking">Booking Issue</option>
                <option value="payment">Payment Problem</option>
                <option value="refund">Refund Request</option>
                <option value="technical">Technical Support</option>
                <option value="general">General Inquiry</option>
              </select>
              
              <textarea
                placeholder="Describe your issue or question *"
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                required
                rows="5"
                style={{
                  padding: '12px 16px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.3s',
                  resize: 'vertical'
                }}
              />
              
              <button
                type="submit"
                style={{
                  background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
                  color: 'white',
                  border: 'none',
                  padding: '14px 20px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'transform 0.2s'
                }}
              >
                📤 Send Message
              </button>
            </form>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px', paddingTop: '30px', borderTop: '1px solid #e2e8f0' }}>
          <h3 style={{ color: '#2d3748', marginBottom: '15px' }}>📋 Frequently Asked Questions</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', fontSize: '14px' }}>
            <div style={{ color: '#64748b' }}>• How to cancel booking?</div>
            <div style={{ color: '#64748b' }}>• Refund processing time</div>
            <div style={{ color: '#64748b' }}>• Payment failed issues</div>
            <div style={{ color: '#64748b' }}>• Ticket not received</div>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            ← Back to Home
          </button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ContactSupport;